module.exports = __webpack_public_path__ + "static/media/1920x10801.32f18fff.png";